<template>
    <div class="wrapper">
        <Header/>
        <div class="page-content">
            <slot/>
        </div>
        <Footer/>

        <VibeQuickView v-if="vibeModalId" :key="vibeModalId" :id="Number(vibeModalId)" @close="closeVibeModal" />
        <ToastHost />
    </div>
</template>

<script setup>
import Header from "~/components/System/Header.vue";
import Footer from "~/components/System/Footer.vue";
import VibeQuickView from "~/components/Modals/VibeQuickView.vue";
import ToastHost from "~/components/UI/ToastHost.vue";

const { activeId: vibeModalId, close: closeVibeModal } = useQueryModal('vibe');

useHead({
    meta: [
        {
            name: "zen-verification",
            content:
                "tQURTuacStnwA4v07Zz0LTl3wJT6FGd3Xzs4yWmw8hGhU0WSwgpyloxNhejogdmx",
        },
    ],
});

onMounted(async () => {
    ;(function (m, e, t, r, i, k, a) {
        m[i] =
            m[i] ||
            function () {
                (m[i].a = m[i].a || []).push(arguments);
            };
        m[i].l = 1 * new Date();
        for (var j = 0; j < document.scripts.length; j++) {
            if (document.scripts[j].src === r) {
                return;
            }
        }
        ((k = e.createElement(t)),
            (a = e.getElementsByTagName(t)[0]),
            (k.async = 1),
            (k.src = r),
            a.parentNode.insertBefore(k, a));
    })(
        window,
        document,
        "script",
        "https://mc.yandex.ru/metrika/tag.js?id=106941179",
        "ym",
    );

    ym(106941179, "init", {
        ssr: true,
        webvisor: true,
        clickmap: true,
        ecommerce: "dataLayer",
        referrer: document.referrer,
        url: location.href,
        accurateTrackBounce: true,
        trackLinks: true,
    });
});
</script>
